import { Stack } from '@/react/common/stacks/types';

import { useGitHelmChartInfo } from '../helmChartSourceQueries/useGitHelmChartInfo';

export function useGitChartInfoFromStack(stack?: Stack) {
  return useGitHelmChartInfo(
    {
      chartPath: stack?.HelmChartPath || '',
      reference: stack?.GitConfig?.ReferenceName,
      sourceId: stack?.GitSourceId,
      command: 'chart',
    },
    { enabled: !!stack }
  );
}
